export default {
	"onboardingModal.previous": "Zurück",
	"onboardingModal.next": "Weiter",
} as const;
